export default "__VITE_ASSET__bdcc959d__"